export const PAGE_CONTAINER_WIDTH = 990;
